import helpers from '../js/scripts/front/helpers'

import axios from 'axios'

let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
const locale = $('#front').data('front-locale')

// Axios configuration
axios.defaults.headers.common = {
    'X-CSRF-TOKEN': csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    Accept: 'application/json',
}

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response && error.response.status === 401) {
            helpers.showAlert('info', Lang.get('javascript.browser_expired_session_message'))
        }

        if (error.response && error.response.status === 419) {
            helpers.showAlert('info', Lang.get('javascript.csrf_token_expired_message'))
        }

        if (error.response && error.response.status === 400) {
            helpers.showAlert('info', error.response.data.data.message)
        }

        return Promise.reject(error)
    },
)

window.axios = axios
